import AnalyticsTitle from "../AnalyticsTitle";
import { tt } from "../../../../utils/i18n/i18n";
import GeneralBarChart from "../graphs/GeneralBarChart";
import PieGraph from "../graphs/PieGraph";
import React, { useMemo } from "react";
import AnalyticsData from "../../model/AnalyticsData";
import TitleAndTwoColumns from "../layout/TitleAndTwoColumns";
import getDefaultTitleForCTA from "../../../../utils/helpers/getDefaultTitleForCTA";

interface Props {
  data: AnalyticsData | undefined;
}

export default function (props: Props) {
  const totalReturnReferral = useMemo(() => {
    return (
      props.data?.distributionShareAndWOM?.find((d) => d._id === "SentSponsor")
        ?.count || 0
    );
  }, [props.data]);

  if (!totalReturnReferral) {
    return null;
  }

  return (
    <TitleAndTwoColumns
      title={
        <AnalyticsTitle
          title={tt("analytics_total_referral_title", {
            totalReturnReferral
          })}
        />
      }
      left={
        <GeneralBarChart
          chartData={props.data?.distributionShareAndWOM}
          title={tt("analytics_distribution_share_wom_title")}
          useLegend={true}
          getLegendName={getDistributionWOMLegendName}
        />
      }
      right={
        <PieGraph
          title={tt("analytics_actions_by_sponsoree_title")}
          distribution={props.data?.distributionOfCTAsForSponsoree}
          getDisplayNameForLabel={getDefaultTitleForCTA}
          suffix={tt("analytics_actions_suffix")}
        />
      }
    />
  );
}

export const getDistributionWOMLegendName = (_id: any) => {
  switch (_id) {
    case "SentSponsor":
      return tt("sent_sponsor_legend");
    case "AuthenticatedSponsorees":
      return tt("sponsoree_authenticated_legend");
    case "DriveToStore":
      return tt("drive_to_store_legend");
    default:
      return "xxx";
  }
};
